<template>
  <TitleFrame text="利用規約への同意">
    <template slot="contents">
      <ConsentCheck :is-test=isTest @click-agree="onClickAgree" />
    </template>
  </TitleFrame>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TitleFrame from '@/components/Templates/TitleFrame'
import ConsentCheck from '@/components/Organisms/ConsentCheck'
import Firebase from './../../firebase'

export default {
  name: 'consent-page',
  components: {
    TitleFrame,
    ConsentCheck
  },
  computed: {
    ...mapState(['isTest', 'uid', 'isAgreed']),
    coockieUid () {
      return this.$cookies.get('uid')
    }
  },
  methods: {
    ...mapMutations(['changeUid', 'loadingStart', 'loadingEnd', 'changeCurrentLatLng']),
    onClickAgree () {
      Firebase.agreeConsent()
    }
  },
  watch: {
    uid: {
      immideate: true,
      handler: function () {
        if (!this.coockieUid) {
          // cookieに登録
          this.$cookies.set('uid', this.uid, '365d')
        }
        if (!this.isAgreed) {
          // uid登録した時に、 isAgreedがfalseのままならば未回答の状態なので、同意画面を開始する
          this.loadingEnd()
        }
      }
    },
    isAgreed: {
      immideate: true,
      handler: function () {
        if (this.isAgreed) {
          let changeCurrentLatLng = this.changeCurrentLatLng
          navigator.geolocation.getCurrentPosition(function (position) {
            changeCurrentLatLng({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            })
          },
          function (err) {
            var msgs = [
              err.message,
              '位置情報の取得を許可されていません。',
              '位置情報の取得に失敗しました。',
              '位置情報を取得中にタイムアウトしました。'
            ]
            window.alert(msgs[err.code])
          },
          { maximumAge: 0 })
          this.$router.push({name: 'Settings'})
        } else {
          this.loadingEnd()
        }
      }
    }
  },
  mounted () {
    this.loadingStart()
    if (!this.coockieUid) {
      // cookieの中にUidがなければFirestoreに登録する
      Firebase.putRegistraton()
    } else {
      // cookieの中にUidがあればFirestoreからデータ取得する
      this.changeUid(this.coockieUid)
      Firebase.getRegistraion()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Pages/Consent.vue